import { render, staticRenderFns } from "./FaqSingle.vue?vue&type=template&id=d1325294"
import script from "./FaqSingle.vue?vue&type=script&lang=js"
export * from "./FaqSingle.vue?vue&type=script&lang=js"
import style0 from "./FaqSingle.vue?vue&type=style&index=0&id=d1325294&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports